module.exports = __WEBPACK_EXTERNAL_MODULE_389__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 389
// module chunks = 0